import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-default',
  templateUrl: './default.component.html',
  styleUrls: ['./default.component.css']
})
export class DefaultComponent implements OnInit {

  constructor(private router: Router,
    private route: ActivatedRoute
    ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params.token) {
        sessionStorage.setItem('user_token', params.token);
      }
    });
  }

  goToLogin(){
    this.router.navigate(["/login"]);
  setTimeout(function () { window.location.reload(); }, 5);
  }

}
